import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/library';

import * as S from './styled';

import { ISubscriptionCardCommonProps } from '../types';

import SubscriptionCardWrapper from './SubscriptionCardWrapper';
import SubscriptionCardHeader from './SubscriptionCardHeader';
import { IncludedInYourPlanRow } from './IncludedInYourPlanRow';

const ExpiredSubscription = ({ tabIcon, heading, expirationDate, isUpgrade }: ISubscriptionCardCommonProps) => {
  const { t } = useTranslation();

  return (
    <SubscriptionCardWrapper>
      <SubscriptionCardHeader Icon={tabIcon} heading={heading} isExpired />
      {isUpgrade && <IncludedInYourPlanRow />}
      <S.DateInfo>
        <Text type="caption" color="text-secondary-subdued">
          {t('subscription.text.expiredOn')}
        </Text>
        <Text type="caption" color="text-secondary-subdued">
          {expirationDate}
        </Text>
      </S.DateInfo>
    </SubscriptionCardWrapper>
  );
};

export default ExpiredSubscription;
